import React, { Component } from 'react';
import ScrollWrapper from '../Components/ScrollWrapper';
import Utility from '../../../Utility';
import { connect } from 'react-redux';

import ReactResizeDetector from 'react-resize-detector';

import './Thumbnails.css';

const DEFAULT_THUMB_HEIGHT = 120;
const DEFAULT_THUMB_WIDTH = 160;
const MAX_THUMB_WIDTH_PERCENT = .307; // 1 / 3.25

class Thumbnails extends Component {
	constructor(props) {
		super(props);

		this.thumbnailBaseUrl = '';

		this.state = {
			thumbnailWidth: 160,
			visibleSet: false,
			focusedThumbnail: 0
		};

		this.windowWidth = this.props.data.dimensions.windowWidth;

		// Initialize thumbs
		if (this.props.data.selectedThumbnails.length > 0) {
			this.state.visibleSet = this.getVisibleThumbs();
		}

		this.thumbnailsRef = React.createRef();
	}

	getVisibleThumbs = () => {
		var thumbSet = {},
			type = this.props.data.selectedThumbnails[0],
			index = this.props.data.selectedThumbnails[1],
			baseUrl = this.props.data.recording.mediaPrefix + this.props.data.recording.sitekey + '/';

		switch(type) {
			case 'slides':
				// Normal slides
				thumbSet.thumbnails = this.props.data.recording.info.thumbnails;
				thumbSet.baseUrl = baseUrl + this.props.data.recording.info.thumbnails_folder + '/t';
				thumbSet.width = 160;
										   // Count of thumbs 								  // Thumbnail width plus padding
				thumbSet.scrollableWidth = this.props.data.recording.info.thumbnails.length * (thumbSet.width + 20);
				break;
			case 'a':
			case 'w':
				var aux_sources = this.props.data.recording.info.aux_sources;
				thumbSet.thumbnails = aux_sources[index].thumbnails;
				thumbSet.baseUrl = baseUrl + aux_sources[index].folder + '/' + aux_sources[index].prefix + 't';
				thumbSet.height = aux_sources[index].thumbHeight ? aux_sources[index].thumbHeight : DEFAULT_THUMB_HEIGHT;
				thumbSet.width = aux_sources[index].thumbWidth ? aux_sources[index].thumbWidth : DEFAULT_THUMB_WIDTH;

				// Now scale up width so its height is 120
				thumbSet.width = (thumbSet.width/thumbSet.height)*DEFAULT_THUMB_HEIGHT;

				// We have a width value - make sure it isn't wider than the widest we can be, minus the padding we add on later
				var max_allowable_width = this.windowWidth*MAX_THUMB_WIDTH_PERCENT - 20;

				// First shrink so that it is equal to the max allowable width
				if (thumbSet.width > max_allowable_width) {
					thumbSet.width = max_allowable_width;
				}

				if (thumbSet.width < DEFAULT_THUMB_WIDTH) {
					thumbSet.width = DEFAULT_THUMB_WIDTH;
				}

										   // Count of thumbs 					  // Thumbnail width plus padding
				thumbSet.scrollableWidth = aux_sources[index].thumbnails.length * (thumbSet.width + 20);
				break;
			default:
				// Do nothing
		}

		return thumbSet;
	}

	componentDidMount() {
		// Listen to previous/next commands
		document.addEventListener('player.previousThumbnail', this.previousThumbnail);
		document.addEventListener('player.nextThumbnail', this.nextThumbnail);
	}

	componentWillUnmount() {
		// Listen to previous/next commands
		document.addEventListener('player.previousThumbnail', this.previousThumbnail);
		document.addEventListener('player.nextThumbnail', this.nextThumbnail);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.data.selectedThumbnails !== this.props.data.selectedThumbnails) {
			this.setState({ visibleSet: this.getVisibleThumbs() });
		}
	}

	thumnbailClickedHandler = (time, index) => {
		Utility.emit('player.thing.select');
		this.props.trigger('seekonly', time);
		this.logSeek(time);
		this.setState({ focusedThumbnail: index });
	}

	previousThumbnail = () => {
		Utility.emit('player.thing.select');
		var selectedIndex = Utility.getIndexofThingByTime(this.props.dynamic.currentTime, this.state.visibleSet.thumbnails);
		selectedIndex = Math.max(0, selectedIndex-1);
		this.props.trigger('seekonly', this.state.visibleSet.thumbnails[selectedIndex][1]);
		this.logSeek(this.state.visibleSet.thumbnails[selectedIndex][1]);
		this.setState({ focusedThumbnail: selectedIndex });
	}

	nextThumbnail = () => {
		Utility.emit('player.thing.select');
		var selectedIndex = Utility.getIndexofThingByTime(this.props.dynamic.currentTime, this.state.visibleSet.thumbnails);
		selectedIndex = Math.min(this.state.visibleSet.thumbnails.length-1, selectedIndex+1);
		this.props.trigger('seekonly', this.state.visibleSet.thumbnails[selectedIndex][1]);
		this.logSeek(this.state.visibleSet.thumbnails[selectedIndex][1]);
		this.setState({ focusedThumbnail: selectedIndex });
	}

	logSeek = (current_time) => {
		Utility.logUserInteractionNoGA('player_seeked', {}, { current_time: current_time });
	}

	onResizeHandler = (width) => {
		this.windowWidth = width;
		this.setState({
			visibleSet: this.getVisibleThumbs()
		});
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		// if only currentTime updated, check if we would still be on the same thumbnail
		if(this.state !== nextState) {
			return true;
		}
		for(const key in nextProps) {
			if(key !== "dynamic" && this.props[key] !== nextProps[key]) {
				return true;
			}
		}
		// dynamic was the only changed prop, we only use dynamic.currentTime
		const oldIndex = Utility.getIndexofThingByTime(this.props.dynamic.currentTime, this.state.visibleSet.thumbnails);
		const newIndex = Utility.getIndexofThingByTime(nextProps.dynamic.currentTime, nextState.visibleSet.thumbnails);
		if(oldIndex !== newIndex) {
			return true;
		}

		// nothing would have changed
		return false;
	}

	scrollerKeydown = (ev) => {
		switch (ev.key) {
			case 'Enter': // ←
				this.thumnbailClickedHandler(this.state.visibleSet.thumbnails[this.state.focusedThumbnail][1], this.state.focusedThumbnail);
				ev.stopPropagation();
				break;
			case 'ArrowLeft': // ←
				this.setState({
					focusedThumbnail: Math.max((this.state.focusedThumbnail-1), 0)
				});
				ev.stopPropagation();
				ev.preventDefault();
				break;
			case 'ArrowRight': // →
				this.setState({
					focusedThumbnail: Math.min(this.state.focusedThumbnail+1, this.state.visibleSet.thumbnails.length-1)
				});
				ev.stopPropagation();
				ev.preventDefault();
				break;
			case 'Tab':
				this.setState({
					focusedThumbnail: Utility.getIndexofThingByTime(this.props.dynamic.currentTime, this.state.visibleSet.thumbnails)
				});
				break;
			default:
				// do nothing
		}
	}

	thumbnailsClick = (ev) => {
		// If a mouse click caused it to focus, blur the thumbnail strip
		this.thumbnailsRef.current.blur();
	}

	// Uncommenting these lines introduces a bug where the thumb strip jumps around "randomly"
	// In essence, the position is being incorrectly calculated by the time BEFORE it advances to the clicked slide
	// This code should only run when keyboard navigation is being used - implemented above in the Keydown handler

	// thumbnailsBlur = (ev) => {
	// 	// when the mouse or user exits this control, make sure to set the focused = current
	// 	this.setState({
	// 		focusedThumbnail: Utility.getIndexofThingByTime(this.props.dynamic.currentTime, this.state.visibleSet.thumbnails)
	// 	});
	// }

	render() {
		if (!this.state.visibleSet && !this.state.visibleSet.thumbnails) {
			return null;
		}

		var selectedIndex = Utility.getIndexofThingByTime(this.props.dynamic.currentTime, this.state.visibleSet.thumbnails);
		let focusedIndex = 0;

		var position = 0;
		// If we are focused on thumbnails, calculate position based on focusedThumbnail as the user is using keyboard control,
		// but if not, use selectedIndex
		if (this.thumbnailsRef.current === document.activeElement) {
			position = this.state.focusedThumbnail * (this.state.visibleSet.width + 20);
			focusedIndex = this.state.focusedThumbnail;
		} else {
			position = selectedIndex * (this.state.visibleSet.width + 20);
			focusedIndex = selectedIndex;
		}

		return(
			<ScrollWrapper id="thumbnail-wrapper" position={position} minimap={false} scrollbar={true} originalImageDimensions={{ w: this.state.visibleSet.scrollableWidth, h: 20}} width={this.state.visibleSet.scrollableWidth} height={this.props.data.dimensions.thumbnailsHeight} noKeyboardScroll>
				<div className="visuallyhidden" aria-live="polite" aria-atomic>
					{ this.state.visibleSet.thumbnails[this.state.focusedThumbnail] ?
						"Slide " + (this.state.focusedThumbnail+1) + " of " + this.state.visibleSet.thumbnails.length + " at " + Utility.sec2hmsLong(this.state.visibleSet.thumbnails[this.state.focusedThumbnail][1]) : null
					}
				</div>
				<div ref={this.thumbnailsRef} tabIndex="0" onClick={this.thumbnailsClick} onKeyDown={this.scrollerKeydown} className="thumbnails" role="list" aria-label={"Thumbnail navigation (" + this.state.visibleSet.thumbnails.length + " tumbnails)"} style={{ width: this.state.visibleSet.scrollableWidth + 'px' }}>
					{this.state.visibleSet.thumbnails.map((imageArray, index) => {
						return(<Thumbnail focused={focusedIndex === index} selected={selectedIndex === index} key={index} thumbIndex={index} thumbnailBaseUrl={this.state.visibleSet.baseUrl} width={this.state.visibleSet.width + 20} height={this.state.visibleSet.height} imageArray={imageArray} thumnbailClicked={this.thumnbailClickedHandler} />);
					})}
				</div>
				<ReactResizeDetector handleWidth onResize={this.onResizeHandler} refreshMode="debounce" refreshOptions={{ leading: false, trailing: true }} refreshRate={250} />
			</ScrollWrapper>
		);
	}
}

const mapStateToProps = (state) => ({
	dynamic: state.dynamic
});

export default connect(mapStateToProps)(Thumbnails);


let Thumbnail = (props) => {
	let lastPositionX = 0;

	let onMouseDownHandler = (ev) => {
		lastPositionX = ev.clientX;
	}

	let onMouseUpHandler = (ev) => {
		var currentPositionX = ev.clientX;

		if (lastPositionX === currentPositionX) {
			props.thumnbailClicked(props.imageArray[1], props.thumbIndex);
		}
	}

	let thumbOver = () => {
		Utility.emit('player.showtimecode', props.imageArray[1]);
	}

	let thumbOut = () => {
		Utility.emit('player.hidetimecode');
	}

	return(
		<div role="listitem" aria-label={"Thumbnail at " + Utility.sec2hmsLong(props.imageArray[1])} className={'thumbnail' + (props.selected === true ? ' thumbnail-selected' : '') + (props.focused === true ? ' thumbnail-focused' : '')} style={{ width: props.width + 'px' }} onMouseDown={onMouseDownHandler} onMouseUp={onMouseUpHandler} onMouseOver={thumbOver} onMouseOut={thumbOut}>
			{props.imageArray[0] === null ? <div style={{ width: (props.width - 20) + 'px', height: '120px' }}>No Signal</div> : <div style={{ width: (props.width - 20) + 'px', backgroundImage: 'url(' + props.thumbnailBaseUrl + props.imageArray[0] + '.jpg)' }}></div>}
		</div>
	);
}

